<template>
  <div>
    <PageHeader/>

    <h1 class="text-center responsive dark-header">
      <img v-if="getSubscription === 'funkwerks' && !isSuccessPage" class="funkwerks-image" src="../assets/images/funkwerks_logo.png">
      <img v-if="getSubscription === 'hopbomb' && !isSuccessPage" class="hopbomb-image" src="../assets/images/hopbomb_logo.png">
      <img v-if="getSubscription === 'bronxbrewery' && !isSuccessPage" class="bronxbrewery-image" src="../assets/images/bronxbrewery_logo.png">
      <img v-if="getSubscription === 'cider' && !isSuccessPage" class="cider-image" src="../assets/images/cider_logo.png">
      <img v-if="getSubscription === 'kuiuanchorage' && !isSuccessPage" class="kuiu-anchorage-image" src="../assets/images/anchorage_logo.png">
      {{pageTitleText}}
      <div v-if="pageTitleSubtext && !isSuccessPage" v-bind:class="subtextClass" >{{pageTitleSubtext}}</div>
      <div v-if="getSubscription === 'kuiuanchorage' && isSuccessPage" class="success-page-subtext">DOWNLOAD THE APP</div>
    </h1>


    <h2 v-if="busy">loading...</h2>

    <component v-bind:is="currentView" @success="setView" @login="routeLogin" @register="routeZipAndAge"/>


  </div>
</template>

<script>
  import store from '../lib/store';
  import PageHeader from '../components/helpers/PageHeader';
  import Start from '../components/start/Start';
  import Login from '../components/start/Login';
  import ZipAndAge from '../components/start/ZipAndAge';
  import Steps from '../components/Steps';
  import Subscriber from '../components/helpers/Subscriber';
  import SuccessFunkwerks from '../components/success/SuccessFunkwerks';
  import SuccessHopBomb from '../components/success/SuccessHopBomb';
  import SuccessBronxBrewery from '../components/success/SuccessBronxBrewery';
  import SuccessCider from '../components/success/SuccessCider';
  import SuccessKUIUAnchorage from '../components/success/SuccessKUIUAnchorage';

  export default {
    name: 'Home',
    components: {
      PageHeader,
      Start,
      Login,
      ZipAndAge,
      Steps,
      Subscriber,
      SuccessFunkwerks,
      SuccessHopBomb,
      SuccessBronxBrewery,
      SuccessCider,
      SuccessKUIUAnchorage,
    },
    data() {
      return {
        busy: false,
        currentView: 'ZipAndAge',
      };
    },
    methods: {
      setView() {
        let res;
        switch (this.currentView) {
          case 'Start':
            if (store.get('authToken')) {
              res = 'Steps';
            } else {
              res = 'ZipAndAge';
            }
            break;
          case 'ZipAndAge':
            res = 'Steps';
            break;
          case 'Login':
            res = 'Steps';
            break;
          case 'Steps':
            res = 'Subscriber';
            break;
          case 'Subscriber':
            res = this.chooseSuccessPage();
            break;
          default:
          // do nothing
        }
        this.currentView = res;
      },
      chooseSuccessPage() {
        let res;
        switch (store.get('subscription')) {
          case 'hopbomb':
            res = 'SuccessHopBomb';
            break;
          case 'funkwerks':
            res = 'SuccessFunkwerks';
            break;
          case 'bronxbrewery':
            res = 'SuccessBronxBrewery';
            break;
          case 'cider':
            res = 'SuccessCider';
            break;
          case 'kuiuanchorage':
            res = 'SuccessKUIUAnchorage';
            break;
          default:
          // do nothing
        }
        return res;
      },
      routeLogin() {
        this.currentView = 'Login';
      },
      routeZipAndAge() {
        this.currentView = 'ZipAndAge';
      },
    },
    computed: {
      pageTitleText() {
        if (this.currentView.includes('Success')) {
          return store.get('title_success');
        }
        return store.get('title_in_progress');
      },
      getSubscription() {
        return store.get('subscription');
      },
      pageTitleSubtext() {
        const subtext = store.get('title_subtext');
        if (subtext) {
          return subtext;
        }
        return false;
      },
      isSuccessPage() {
        return this.currentView.includes('Success');
      },
      subtextClass() {
        return this.getSubscription === 'kuiuanchorage' ? 'text-center responsive subtext-lg kuiu-anchorage-subtext' : 'text-center responsive subtext-lg';
      },
    },
  };
</script>

<style scoped>
  .funkwerks-image {
    height: 45px;
    width: 45px;
    margin-bottom: -18px;
  }
  .hopbomb-image {
    height: 60px;
    width: 60px;
    margin-bottom: -30px;
    margin-right: -15px;
  }
  .bronxbrewery-image {
    height: 60px;
    width: 60px;
    margin-bottom: -30px;
  }
  .cider-image {
    height: 60px;
    width: 60px;
    margin-bottom: -30px;
  }
  .kuiu-anchorage-image {
    height: 80px;
    margin-bottom: -45px;
    width: auto;
    margin-right: 25px;
  }
  .kuiu-anchorage-subtext {
    margin-left: 450px;
    color: white;
    font-size: 20px;
  }
  .success-page-subtext {
    font-size:24px;
  }
  .dark-header {
    background-color: rgba(1,1,1,.6);
    color: white;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  @media screen and (max-width: 35.5em) {
    .funkwerks-image {
      height: 25px;
      width: 25px;
      margin-bottom: -15px;
    }
    .hopbomb-image {
      height: 35px;
      width: 35px;
      margin-bottom: -15px;
      margin-right: -5px;
    }
    .bronxbrewery-image {
      height: 35px;
      width: 35px;
      margin-bottom: -15px;
      margin-right: -5px;
    }
    .cider-image {
      height: 35px;
      width: 35px;
      margin-bottom: -15px;
      margin-right: -5px;
    }
    .kuiu-anchorage-image {
      width: 100%;
      height: auto;
      margin-bottom: 0;
    }
    .kuiu-anchorage-subtext {
      margin-left: 0;
    }
    .success-page-subtext {
      font-size: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// Home.vue?4b0a6d70